import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// Disponibilidad semanal del docente (D8). weekday: 0=domingo … 6=sábado.
function useMyAvailability() {
  return useQuery({
    queryKey: ["my-availability"],
    queryFn: () => apiClient.get("/api/v1/me/availability/").then((r) => r.data),
  });
}

function useCreateAvailability() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiClient.post("/api/v1/me/availability/", data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["my-availability"] }),
  });
}

function useDeleteAvailability() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiClient.delete(`/api/v1/me/availability/${id}/`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["my-availability"] }),
  });
}

export { useMyAvailability, useCreateAvailability, useDeleteAvailability };
